import { render } from "./EditingSeasons.vue?vue&type=template&id=c5423048"
import script from "./EditingSeasons.vue?vue&type=script&lang=js"
export * from "./EditingSeasons.vue?vue&type=script&lang=js"
script.render = render

export default script